module.exports = __webpack_public_path__ + "./YiShanPhoto_22b2d8c7f3cf2025bf8660940ea0e2ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/YiShanPhoto.png
// module id = 513
// module chunks = 0